// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:17
import { GeoSectorNode_abstract } from './../abstract/SagaSchema/GeoSectorNode_abstract';
export class GeoSectorNode extends GeoSectorNode_abstract {}
